// @TODO WMG1-662 - Implement platforms component
export function Platforms() {
  return <div data-testid="platforms" />;
}

Platforms.displayName = 'Platforms';
